/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneratedNotePagedList } from '../../models/generated-note-paged-list';
import { GeneratedNoteSearchBody } from '../../models/generated-note-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchNoteGenerated$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the notification's name
 *   * DATE : Date of the note creation
 *   * CATEGORY : Category of the note
 */
  sortFieldName?: 'NAME' | 'DATE' | 'CATEGORY';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search generated notes
     */
    body?: GeneratedNoteSearchBody
}

export function searchNoteGenerated$Json(http: HttpClient, rootUrl: string, params?: SearchNoteGenerated$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchNoteGenerated$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneratedNotePagedList>;
    })
  );
}

searchNoteGenerated$Json.PATH = '/custom/notes-generated/search';
